import { lazy, Suspense } from "react";

import { Spinner } from "@app/components/spinners/spinner";

const ImporterExperimentalLoaderScenario = lazy(() => {
  return new Promise<{ default: React.FC }>((resolve, reject) => {
    import("experimental/lib")
      .then((lib) => {
        resolve({
          default: () => <lib.default.LoaderPageScenario />,
        });
      })
      .catch(reject);
  });
});

export const LazyExperimentalLoaderScenario = () => {
  return (
    <Suspense fallback={<Spinner height={"100vh"} />}>
      <ImporterExperimentalLoaderScenario />
    </Suspense>
  );
};
